import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Button } from '@material-ui/core'
import WarningIcon from '@material-ui/icons/Warning'
import { FormLoader } from '../../components/Loader/FormLoader'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import { InvoicesListingConsumer } from '../../context/InvoicesListingContext'

const DeclineCancelRejectConfirmation = () => {
  const classes = formStyles()
  return (
    <InvoicesListingConsumer>
      {({ currentSelectedRow, currentDialogAction, cancelDialog, dialogActionSubmit, actionItemLoading }) => (
        <Box className={classes.DeleteWrapper}>
          {!!actionItemLoading && <FormLoader loading={true}/>}

          <WarningIcon className={classes.DeleteWarningIcon}/>
          <p><FormattedMessage id={`InvoiceActions.${currentDialogAction}.Message`}
                               values={{ name: currentSelectedRow?.uuid || '' }}/></p>


          <div className={classes.FormSubmitRow}>
            <Button type="submit" variant='contained' size={'large'} color={'secondary'}
                    onClick={(event) => dialogActionSubmit()}>
              <FormattedMessage id={`AddNewDialog.InvoiceActions.${currentDialogAction}`}/>
            </Button>
            <Button variant='outlined' color='secondary'
                    onClick={cancelDialog} className={'cancel'}>
              <FormattedMessage id='invoiceSteps.Cancel'/>
            </Button>
          </div>
        </Box>
      )}
    </InvoicesListingConsumer>
  )
}

export default DeclineCancelRejectConfirmation
